import BaseApi from "./BaseApi";

export default class Company extends BaseApi {
    construct() {}

    static async getAll() {
        return await Company.getAxiosInstance().get(Company.getApiUrl() + "/all");
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "companies";
    }
}